import chroma from 'chroma-js';

export const partyColorIndex = {
  Republican: chroma('#BC2929'),
  Democrat: chroma('#5586EF'),
  Independent: chroma('#3BAC69'),
};
